import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useAppContext from "../hooks/useAppContext";

const Login = () => {
  const navigate = useNavigate();
  const { authInfo } = useAppContext();
  const { setUser, setToken } = authInfo;
  const api_url = process.env.REACT_APP_API_URL;

  const [isLoading, setIsLoading] = useState(false);
  const [inputType, setInputType] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setLongitude(position.coords.longitude);
        setLatitude(position.coords.latitude);
      });
    } else {
      toast.error("Geolocation is not supported by this browser.", {
        hideProgressBar: true,
        theme: "colored",
      });
    }
  }, []);

  const toggleType = () => {
    setInputType((current) => !current);
  };

  // Phone number and OTP submit function
  const loginForm = (formData) => {
    try {
      setIsLoading(true);
      fetch(api_url + "auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            const outlet = {
              outlet_code: data.user.outlet_code,
              outlet: data.user.outlet,
              staff_id: data.user.staff_id,
              longitude: longitude,
              latitude: latitude,
            };
            fetch(api_url + "outlets", {
              method: "POST",
              headers: {
                authorization: data.token,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(outlet),
            })
              .then((response) => response.json())
              .then((data) => data)
              .catch((error) => console.log(error));
            setUser(data.user);
            setToken(data.token);
            localStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("token", data.token);
            setIsLoading(false);
            if (data.user.role === "admin") {
              navigate("/dashboard/admin");
            } else {
              navigate("/dashboard/employee");
            }
          } else {
            setIsLoading(false);
            let message = data.message;
            toast.error(message, {
              hideProgressBar: true,
              theme: "colored",
            });
          }
        })
        .catch((error) => console.log(error));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="login h-[90vh] flex items-center justify-center">
      <div className="form-container lg:w-1/3 md:w-1/2 w-5/6 mx-auto">
        <div className="page-title text-lg text-center font-medium mb-5">
          Login to Time
          <span className="text-[#EB4B50]">ly</span>
        </div>
        <form onSubmit={handleSubmit(loginForm)}>
          <ToastContainer transition={Slide} />
          <div className="mb-4 relative">
            <input
              type="text"
              name="staff_id"
              className="w-full bg-[#F6F6F6] border border-[#E8E8E8] rounded text-base focus:outline-0 focus:border-transparent focus:ring-[#E8E8E8]"
              placeholder="staff id"
              {...register("staff_id", {
                required: "Staff id is required",
                minLength: {
                  value: 4,
                  message: "Minimum 4 digit staff id",
                },
                maxLength: {
                  value: 5,
                  message: "Maximum 5 digit staff id",
                },
                pattern: {
                  value: /^[0-9]*$/,
                  message: "Invalid staff id",
                },
              })}
            />
            {errors.staff_id && (
              <p className="text-xs text-red-500 absolute -bottom-5">
                {errors.staff_id.message}
              </p>
            )}
          </div>
          <div className="relative mt-7 mb-4">
            <input
              type={inputType ? "text" : "password"}
              name="password"
              className="w-full bg-[#F6F6F6] border border-[#E8E8E8] rounded text-base focus:outline-0 focus:border-transparent focus:ring-[#E8E8E8]"
              placeholder="password"
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 11,
                  message: "Invalid password",
                },
              })}
            />
            <button
              type="button"
              className="absolute top-0 right-0 p-2 text-sm font-medium text-brand rounded border-0 focus:ring-0 focus:outline-none"
              onClick={toggleType}
            >
              {inputType ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              )}
            </button>
            {errors.password && (
              <p className="text-xs text-red-500 absolute -bottom-5">
                {errors.password.message}
              </p>
            )}
          </div>
          <div className="button mt-8">
            {isLoading ? (
              <button className="w-full rounded text-sm bg-brand text-white font-semibold capitalize p-3">
                <svg
                  aria-hidden="true"
                  className="inline w-4 h-4 text-white animate-spin fill-black"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span className="ml-2">Logging.........</span>
              </button>
            ) : (
              <button
                type="submit"
                className="w-full rounded text-sm bg-brand text-white font-semibold capitalize p-3"
                disabled={isLoading}
              >
                login
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
